import { render, staticRenderFns } from "./asset-and-alarms.vue?vue&type=template&id=0d8c0051&scoped=true&"
import script from "./asset-and-alarms.vue?vue&type=script&lang=js&"
export * from "./asset-and-alarms.vue?vue&type=script&lang=js&"
import style0 from "./asset-and-alarms.vue?vue&type=style&index=0&id=0d8c0051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c0051",
  null
  
)

export default component.exports